// src/components/StatsBar.jsx
import React from 'react';
import { formatCurrency } from '../utils/formatters';

export default function StatsBar({ tenants }) {
  const totalRent = tenants.reduce((sum, t) => sum + (t.monthlyRent || 0), 0);
  const totalBalance = tenants.reduce((sum, t) => sum + (t.currentBalance || 0), 0);
  const collected = Math.max(totalRent - totalBalance, 0);
  const highRisk = tenants.filter(t => t.risk?.tier === 'high').length;
  const mediumRisk = tenants.filter(t => t.risk?.tier === 'medium').length;
  const atRiskDollars = tenants
    .filter(t => t.risk?.tier === 'high' || t.risk?.tier === 'medium')
    .reduce((sum, t) => sum + (t.currentBalance || 0), 0);
  const collectionRate = totalRent > 0 ? Math.round((collected / totalRent) * 100) : 100;

  const stats = [
    { label: 'Expected This Month', value: formatCurrency(totalRent), sub: 'total rent roll', variant: 'neutral' },
    { label: 'Collected', value: formatCurrency(collected), sub: collectionRate + '% collection rate', variant: 'success' },
    { label: 'Amount At Risk', value: formatCurrency(atRiskDollars), sub: (highRisk + mediumRisk) + ' tenants at risk', variant: atRiskDollars > 0 ? 'warning' : 'neutral' },
    { label: 'High Risk Tenants', value: highRisk, sub: 'require immediate action', variant: highRisk > 0 ? 'danger' : 'neutral' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, i) => {
        const border = stat.variant === 'danger' ? 'border-red-200' : stat.variant === 'warning' ? 'border-amber-200' : 'border-gray-200';
        const valColor = stat.variant === 'danger' ? 'text-red-600' : stat.variant === 'warning' ? 'text-amber-600' : stat.variant === 'success' ? 'text-green-600' : 'text-gray-900';
        return (
          <div key={i} className={"bg-white rounded-2xl border p-5 " + border}>
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">{stat.label}</p>
            <p className={"text-2xl font-bold mt-1 " + valColor}>{stat.value}</p>
            <p className="text-xs text-gray-400 mt-1">{stat.sub}</p>
          </div>
        );
      })}
    </div>
  );
}
